<template>
  <div>
    <c-tab
      :dense="true"
      type="pagetop"
      align="left"
      :inlineLabel="true"
      :height="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
        />
      </template>
    </c-tab>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'con-exa-history-tab',
  data() {
    return {
      tab: 'consultHistory',
      tabItems: [
        { name: 'consultHistory', icon: 'person_search', label: '상담이력', component: () => import(`${'./consultHistory.vue'}`) },
        { name: 'examineHistory', icon: 'colorize', label: '검진이력', component: () => import(`${'./examineHistory.vue'}`) },
      ],
      period: [ '', ''],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      contentHeight: null,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
    },
    tabClick() {
      this.count++;
    }
  }
};
</script>
